import gql from 'graphql-tag';

import type { TargetAudienceInsights } from 'src/data/audiencesTargeting';
import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { FRAGMENT_TARGET_AUDIENCE_INSIGHTS } from 'src/graphql/schema';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationExtractTargetAudienceInsightsArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractTargetAudienceInsights(
    $projectId: ID!
    $generationTool: GenerationToolEnum!
    $text: String
    $variationId: ID
    $brandVoiceId: ID
    $scoringMethod: ScoringMethodInput
  ) {
    extractTargetAudienceInsights(
      projectId: $projectId
      generationTool: $generationTool
      text: $text
      variationId: $variationId
      brandVoiceId: $brandVoiceId
      scoringMethod: $scoringMethod
    ) {
      ...TargetAudienceInsights
    }
  }
  ${FRAGMENT_TARGET_AUDIENCE_INSIGHTS}
`;

type Variables = BackendMutationExtractTargetAudienceInsightsArgs;

export const extractTargetAudienceInsights = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
): Promise<TargetAudienceInsights[] | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<TargetAudienceInsights[]>(result.data);
};
